// Shared environment configuration
export type EnvironmentType = {
  production: boolean;
  requiredRoles: string[];
  requiredPermissions: Record<string, string[]>;
  adminEmail: string;
  adminRoleName: string;
  apiUrl: string;
  // Default license-plate state for new vehicles (the shop's home state).
  defaultState: string;
}

// Base configuration shared across all environments
export const baseEnvironment: Omit<EnvironmentType, 'production' | 'apiUrl'> = {
  requiredRoles: ['SYSTEM_ADMINISTRATOR', 'APPLICATION_USER'],
  requiredPermissions: {
    SYSTEM_ADMINISTRATOR: ['APP_MANAGEMENT', 'ROLE_MANAGEMENT', 'USER_MANAGEMENT', 'PRODUCT_MANAGEMENT', 'ORDER_MANAGEMENT', 'CHECKOUT'],
    APPLICATION_USER: ['CHECKOUT', 'ORDER_MANAGEMENT']
  },
  adminEmail: 'admin@example.com',
  adminRoleName: 'SYSTEM_ADMINISTRATOR',
  defaultState: 'AL'
};
